import { Braces } from "lucide-react";
import { ModalSectionLayout } from "./ModalSectionLayout";
import { CopyJsonButton } from "./CopyJsonButton";
import { NoxusJsonView } from "@/components/UI/NoxusJsonView";
import { NoxusEmptyBlock } from "@/components/UI/NoxusEmptyBlock";
import type { ActiveCredential } from "./types";

export function CredentialMetadataPanel({ cred }: { cred: ActiveCredential }) {
  return (
    <ModalSectionLayout
      title="Metadata"
      description="Raw metadata returned by the provider."
    >
      {cred.meta && Object.keys(cred.meta).length > 0 ? (
        <div className="relative rounded-lg border border-border/60 bg-muted/20">
          <div className="flex items-center justify-between px-3 py-1 border-b border-border/40 bg-muted/30">
            <span className="text-xs font-medium text-muted-foreground px-1">
              Content
            </span>
            <CopyJsonButton data={cred.meta} />
          </div>
          <div className="overflow-auto min-w-0">
            <div className="px-3 py-2 pr-6 w-fit min-w-full">
              <NoxusJsonView data={cred.meta} navigable={false} />
            </div>
          </div>
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center h-full">
          <div className="text-center space-y-3">
            <Braces size={32} className="mx-auto text-muted-foreground/40" />
            <p className="text-sm text-muted-foreground">
              No metadata available for this connection
            </p>
          </div>
        </div>
      )}
    </ModalSectionLayout>
  );
}
